// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + ".js?" + "47e484eb62f261a5a9f9" + "";
};